import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '@shared/services/theme.service';
import { UserPreferencesService } from '@shared/services/usuario/user-preferences.service';
import { NotificationService } from '@shared/services/notificacion/notification.service';

@Component({
  selector: 'app-theme-toggle-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './theme-toggle-button.component.html',
})
export class ThemeToggleButtonComponent {
  private themeService = inject(ThemeService);
  private userPreferencesService = inject(UserPreferencesService);
  private notification = inject(NotificationService);

  // Ahora usamos la signal directamente, sin $
  theme = this.themeService.theme;

  toggleTheme() {
    this.themeService.toggleTheme();

    const newTheme = this.theme();
    const prefs = {
      theme: newTheme,
      language: 'es',
      notificationsEnabled: true
    };

    this.userPreferencesService.updatePreferences(prefs).subscribe({
      next: () => {
        this.notification.success(
          'Preferencias actualizadas',
          'Tus preferencias se guardaron correctamente.'
        );
      },
      error: () => {
      }
    });
  }
}

